import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Alert, Snackbar, Stack } from '@mui/material';
import TablePortal from './TablePortal';
import Service from '../../../util/Service';

const steps = ['Bem vindo', 'Definir paginas', 'Criar paginas', 'Cadastrar Estrutura da organização'];

export default function AssistentePage() {
    const [activeStep, setActiveStep] = React.useState(0);
    const [completed, setCompleted] = React.useState({});
    const [paginaRoot, setPaginaRoot] = React.useState();
    const [wait, setWait] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
      setOpen(true);
    };
  
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }  
      setOpen(false);
    };

    function buscaPaginaRoot() {
        setWait(true);
        Service.GET('/api/paginaHtml/buscaPorNome/Root').then(r => {
            console.log( r );
            if (r && r.length > 0) {
                setPaginaRoot(r[0]);
                setWait(false);
            }else{
                setOpen(true);
                setMsg("Não encontrado pagina Root. Por favor crie ou importe uma pagina Root conforme o passo 1.")
            }
        }).catch(e => {
            console.error(e);
            setWait(false);
        })
    }
    const totalSteps = () => {
        return steps.length;
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const handleNext = () => {
        const newActiveStep =
            isLastStep() && !allStepsCompleted()
                ? // It's the last step, but not all steps have been completed,
                // find the first step that has been completed
                steps.findIndex((step, i) => !(i in completed))
                : activeStep + 1;
        if (newActiveStep < 3) {
            buscaPaginaRoot();
        }
        setActiveStep(newActiveStep);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step) => () => {
        setActiveStep(step);
    };

    const handleComplete = () => {
        setCompleted({
            ...completed,
            [activeStep]: true,
        });
        handleNext();

        console.log( activeStep )
    };

    const handleReset = () => {
        setActiveStep(0);
        setCompleted({});
    };

    function MontaPasso({ passo }) {
        function Passo1() {
            return (
                <React.Fragment>
                    {/* <Stack > */}
                    <Typography variant='h4' sx={{
                        textAlign: 'center'
                    }} >
                        Assistente virtual do sistema
                    </Typography>
                    <Typography>
                        Alguns passos são necessários para começar a usar o sistema
                    </Typography>
                    <ul>
                        <li>
                            <Typography variant='h6'>
                                Definir pagina inical do sistema
                            </Typography>
                            <Typography variant="body2" sx={{
                                marginTop: 3
                            }}>
                                Recomendamos criar uma pagina chamada Root do tipo Layout. <br />
                                Se possuir um template pode ser importado no sistema. Alguns templates publicos podem ser baixados aqui <a href='#nada'>templates</a><br />
                                Pode ser criadas quantas paginas quanto quiser, mas uma do tipo Root é obrigatório.
                            </Typography>
                            <TablePortal tituloPagina={'Definição pagina principal do sistema - Root'} disableFilter={true} />

                        </li>
                    </ul>
                    {/* </Stack> */}
                </React.Fragment>
            );
        }
        function Passo2() {
            if (wait) {
                return (
                    <Typography variant='h4' sx={{
                        textAlign: 'center'
                    }} >Definição de paginas necessárias buscado informações....
                                            </Typography>
                );
            }
            return (
                <React.Fragment>
                    <Typography variant='h4' sx={{
                        textAlign: 'center'
                    }} >
                        Definição de paginas necessárias
                    </Typography>
                    {!paginaRoot && <Alert severity="info">Pagina Root não cadastrado.<br /> Volte ao passo anterior e crie uma pagina com nome Root</Alert>}
                    {paginaRoot && paginaRoot.layout && paginaRoot.layout.tipo === 'portal' &&
                        <React.Fragment>
                            <Typography variant='h6'>
                                O tipo de pagina escolhido, layout do tipo Portal, é necessario informar as seguintes paginas:
                            </Typography>
                            <ul>
                                <li>
                                    Cabeçalho da pagina:<br />
                                    <Typography variant="body2" sx={{
                                        marginTop: 1
                                    }}>
                                        Crie uma pagina com o nome {paginaRoot.layout.header.pagina} para o cabeçalho do portal
                                    </Typography>
                                </li>
                                <li>
                                    Esquerda da pagina:<br />
                                    <Typography variant="body2" sx={{
                                        marginTop: 1
                                    }}>
                                        Crie uma pagina com o nome {paginaRoot.layout.left.pagina} para a area esquerda do portal, geralmente área de menu
                                    </Typography>
                                </li>
                                <li>
                                    ??:<br />
                                    <Typography variant="body2" sx={{
                                        marginTop: 1
                                    }}>
                                        ???
                                    </Typography>
                                </li>
                                <li>
                                    ??:<br />
                                    <Typography variant="body2" sx={{
                                        marginTop: 1
                                    }}>
                                        ???
                                    </Typography>
                                </li>
                                <li>
                                    ??:<br />
                                    <Typography variant="body2" sx={{
                                        marginTop: 1
                                    }}>
                                        ???
                                    </Typography>
                                </li>
                            </ul>
                            <TablePortal tituloPagina={montaTituloP()}
                                disableFilter={true}
                            />
                        </React.Fragment>
                    }
                </React.Fragment>
            );
        }
        function Passo3() {
            return (
                <React.Fragment>
                    <Typography variant='h4' sx={{
                        textAlign: 'center'
                    }} >
                        Mais paginas e mais
                    </Typography>
                    <Typography variant="body2" sx={{
                        marginTop: 1
                    }}>
                        Esse é um sistema de criação de conteudo, então mais paginas poderão ser criadas.<br />
                        Explores os tipos de paginas que podem ser criadas, entre elas alem de pagina HTML e Layout podem ser criadas
                        codigo( EditorJS) com seus plugins, menus, e soluções pre-fabricadas como Kanban, forum, chat, fluxo BPMn.
                        Fique a vontade para explorar o sistema e montar o sistema conforme suas necessidade.
                    </Typography>
                </React.Fragment>
            );
        }
        function Passo4() {
            return (
                <React.Fragment>
                    <Typography variant='h4' sx={{
                        textAlign: 'center'
                    }} >
                        Organização
                    </Typography>
                    <Typography variant="body2" sx={{
                        marginTop: 1
                    }}>
                        Assim que as paginas iniciais foram cadastradas é importante seguir os seguintes passos:
                    </Typography>
                    <ul>
                        <li>
                            Usuários do sistema
                            <Typography variant="body2" sx={{
                                marginTop: 1
                            }}>
                                Se o sistema não tiver um provedor de usuário, pode ser cadastrado os usuários do sistema direto no portal:
                                <a href='/gerenciar/cadastroUser'> Cadastro de usuários</a>.
                            </Typography>

                        </li>
                        <li>
                            Organograma
                            <Typography variant="body2" sx={{
                                marginTop: 1
                            }}>
                                Castrar um organograma da empresa para o sistema entender as responsabilidade de cada colaborador:
                                <a href='/gerenciar/organograma'> Organograma</a>.
                            </Typography>
                        </li>

                        <li>Destativar usuário Root</li>
                    </ul>
                </React.Fragment>
            );
        }
        return (
            <Box
                sx={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    my: 4,
                    alignItems: "center",
                    gap: 4,
                    p: 1,
                    border: '2px solid grey'
                }}>
                {passo === 1 && <Passo1 />}
                {passo === 2 && <Passo2 />}
                {passo === 3 && <Passo3 />}
                {passo === 4 && <Passo4 />}
            </Box>
        );
    }

    function montaTituloP(){
        let txt = 'Paginas que comporão o portal - ';
        if( paginaRoot.layout.header){
         txt += paginaRoot.layout.header.pagina+" ";
        }
        if( paginaRoot.layout.left) {
            txt += paginaRoot.layout.left.pagina;
        } 
        if( paginaRoot.layout.body){
            txt += paginaRoot.layout.body.pagina + " ";
        }
        if( paginaRoot.layout.right){
            txt += paginaRoot.layout.right.pagina + " ";
        }
        if( paginaRoot.layout.footer ) {
            txt += paginaRoot.layout.footer.pagina
        }

        return txt;
    }

    return (
        <Box
            sx={{
                my: 4,
                width: '100%'
            }}>
            <Stepper nonLinear activeStep={activeStep}>
                {steps.map((label, index) => (
                    <Step key={label} completed={completed[index]}>
                        <StepButton color="inherit" onClick={handleStep(index)}>
                            {label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
            <div>
                {allStepsCompleted() ? (
                    <React.Fragment>
                        <Typography
                            variant='h4'
                            sx={{
                                textAlign: 'center',
                                marginTop: 10
                            }}>
                            Configuração inicial concluida
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button onClick={handleReset}>Refazer</Button>
                            <Button onClick={() => window.location.reload()}>Proceguir</Button>
                        </Box>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <MontaPasso passo={activeStep + 1} />
                        {/* <Typography sx={{ mt: 2, mb: 1, py: 1 }}>
              Passo {activeStep + 1}
            </Typography> */}
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                            <Button
                                color="inherit"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                sx={{ mr: 1 }}
                            >
                                Voltar
                            </Button>
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button onClick={handleNext} sx={{ mr: 1 }}>
                                Proximo
                            </Button>
                            {activeStep !== steps.length &&
                                (completed[activeStep] ? (
                                    <Typography variant="caption" sx={{ display: 'inline-block' }}>
                                        Step {activeStep + 1} already completed
                                    </Typography>
                                ) : (
                                    <Button onClick={handleComplete}>
                                        {completedSteps() === totalSteps() - 1
                                            ? 'Concluir'
                                            : 'Concluir passo'}
                                    </Button>
                                ))}
                        </Box>
                    </React.Fragment>
                )}
            </div>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg}
                </Alert>
            </Snackbar>
        </Box>
    );
}
